module.exports = __webpack_public_path__ + "static/media/40_tn.5a564db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/40_tn.jpg
// module id = 349
// module chunks = 0